import { Form, Formik } from 'formik';
import { useState } from 'react';
import { MdEdit } from 'react-icons/md';
import { toast } from 'react-toastify';
import { useTheme } from 'styled-components';

import settingsApi from '../../../APIs/settings';
import location from '../../../assets/icons/location.svg';
import escConstants from '../../../constants';
import { useRoot } from '../../../context/RootProvider';
import {
  Button,
  FormContainer,
  Input,
  Typography,
} from '../../../designComponents';
import { requestAPI } from '../../../utils';
import { CompanyInformationWrapper } from './style';

const CompanyInformation = () => {
  const theme = useTheme();

  const { auth: user, updateAuth } = useRoot();
  const [loading, setLoading] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [initialValues, _setInitialValues] = useState({
    companyName: user?.companyDetails?.companyName,
  });
  const handleContactInformation = async (values: any) => {
    try {
      setLoading(true);
      const updatedData = await requestAPI(
        settingsApi.updateCompanyInfo({
          companyDetails: {
            companyName: values.companyName || '',
          },
        })
      );
      toast(escConstants.toastMessages.updateCompanyInformation);
      setLoading(false);
      setEditMode(false);
      if (updatedData) {
        updateAuth({ ...updatedData });
      }
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  const handleEdit = () => {
    setEditMode((prev) => !prev);
  };
  return (
    <CompanyInformationWrapper>
      <div className="heading">
        <Typography
          size={14}
          strong
          style={{ marginBottom: '10px' }}
          className="setting-title"
        >
          Company Information
        </Typography>
        {!editMode && (
          <MdEdit
            className="btn-edit"
            onClick={handleEdit}
            style={{ cursor: 'pointer' }}
          />
        )}
      </div>
      <Formik
        initialValues={initialValues}
        onSubmit={handleContactInformation}
        enableReinitialize
      >
        {({ values, setFieldValue, handleSubmit }) => {
          return (
            <Form onSubmit={handleSubmit}>
              <FormContainer
                label="Company Name"
                marginBottom="20px"
                className="label"
              >
                <Input
                  name="companyName"
                  value={values.companyName}
                  onChange={(e) => setFieldValue('companyName', e.target.value)}
                  iconLeft={<img src={location} alt="location icon" />}
                  containerStyle={{
                    borderColor: !editMode
                      ? theme.colors.disable
                      : theme.colors.border,
                  }}
                  disabled={!editMode}
                />
              </FormContainer>
              <div className="btn-update">
                {editMode && (
                  <>
                    <Button
                      isLoading={loading}
                      variant="gray"
                      style={{ marginRight: '18px' }}
                      onClick={handleEdit}
                    >
                      Cancel
                    </Button>
                    <Button type="submit" isLoading={loading}>
                      Update
                    </Button>
                  </>
                )}
              </div>
            </Form>
          );
        }}
      </Formik>
    </CompanyInformationWrapper>
  );
};

export default CompanyInformation;
